import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export const ProfileService = {
  getBasicInfo,
  updateBasicInfo,
  addBasicInfo,
  getDocuments,
  uploadDocument,
  deleteDocument,
  getProfileSoftSkills,
  updateSoftSkill,
  deleteCandidateSkill,
  getProfileSkills,
  updateSkill,
  getProfileLanguages,
  saveLanguages,
  deleteProfileLanguage,
  getProfileCertifications,
  saveCertification,
  getExperience,
  getExperienceById,
  deleteExperience,
  approveResumeParsedExperience,
  addExperience,
  editExperience,
  getEducationsList,
  updateEducationDetails,
  addEducationDetails,
  getCandidateEducation,
  deleteEducation,
  approveParsedEducationService,
  addHighlights,
  getCareerHighlights,
  getPreferences,
  addPreferences,
  addPeerRating,
  updatePeerRating,
  getRatingReview,
  getRating,
  resendRequestService,
  getAveragePeerratingService,
  getCandidateReview,
  getDocument,
  withdrawService,
  applyForJob,
  getAppliedJobsService,
  getAppliedJobDetailsService,
  deleteAppliedJobService,
  getAppliedJobdetails,
  getJobdetails,
  getSuggestions,
  getNotifications,
  updateNotifications,
  deletenotification,
};

function getBasicInfo() {
  return axiosInterceptors
    .get(ENV.basicInfoUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateBasicInfo(candidateBasicInfo) {
  return axiosInterceptors
    .put(ENV.basicInfoUrl, candidateBasicInfo)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addBasicInfo(basicInfoReqest) {
  return axiosInterceptors
    .post(ENV.basicInfoUrl, basicInfoReqest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getDocuments() {
  return axiosInterceptors
    .get(ENV.document_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function uploadDocument(uploadFileObject) {
  return axiosInterceptors
    .post(ENV.upload_document_url, uploadFileObject)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteDocument(id) {
  return axiosInterceptors
    .delete(ENV.document_url + "/" + id + "/delete")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getProfileSoftSkills() {
  return axiosInterceptors
    .get(ENV.softskill_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateSoftSkill(softSkillObj) {
  return axiosInterceptors
    .post(ENV.softskill_url, softSkillObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteCandidateSkill(candidateSkillId) {
  return axiosInterceptors
    .delete(ENV.updateskill_url + "/" + candidateSkillId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getProfileLanguages() {
  return axiosInterceptors
    .get(ENV.language_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function saveLanguages(languageObj) {
  return axiosInterceptors
    .post(ENV.language_url, languageObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteProfileLanguage(languageId) {
  return axiosInterceptors
    .delete(ENV.language_url + "/" + languageId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getProfileCertifications() {
  return axiosInterceptors
    .get(ENV.certification_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function saveCertification(certificationObj) {
  return axiosInterceptors
    .post(ENV.certification_url, certificationObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getExperience() {
  return axiosInterceptors
    .get(ENV.experience_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getExperienceById(experienceId) {
  return axiosInterceptors
    .get(ENV.experience_url + "/" + experienceId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteExperience(experienceId) {
  return axiosInterceptors
    .delete(ENV.experience_url + "/" + experienceId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function approveResumeParsedExperience(expId) {
  return axiosInterceptors
    .post(ENV.approveExperience_url + expId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addExperience(jobExperienceRequest) {
  return axiosInterceptors
    .post(ENV.experience_url, jobExperienceRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function editExperience(jobExperienceRequest, experienceId) {
  return axiosInterceptors
    .put(ENV.experience_url + "/" + experienceId, jobExperienceRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getEducationsList() {
  return axiosInterceptors
    .get(ENV.education_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function approveParsedEducationService(eduId) {
  return axiosInterceptors
    .post(ENV.approveEducation_url + eduId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addEducationDetails(educationRequest) {
  return axiosInterceptors
    .post(ENV.education_url, educationRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getCandidateEducation(educationId) {
  return axiosInterceptors
    .get(ENV.education_url + "/" + educationId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteEducation(educationId) {
  return axiosInterceptors
    .delete(ENV.education_url + "/" + educationId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateEducationDetails(educationRequest, educationId) {
  return axiosInterceptors
    .put(ENV.education_url + "/" + educationId, educationRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getCandidateReview() {
  return axiosInterceptors
    .get(ENV.review_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addPreferences(preferencesRequest) {
  return axiosInterceptors
    .post(ENV.preference_url, preferencesRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getPreferences() {
  return axiosInterceptors
    .get(ENV.preference_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addHighlights(highlightsRequest) {
  return axiosInterceptors
    .post(ENV.highlights_url, highlightsRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getCareerHighlights() {
  return axiosInterceptors
    .get(ENV.highlights_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getDocument(documentId) {
  return axiosInterceptors
    .get(ENV.document_url + "/" + documentId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getProfileSkills() {
  return axiosInterceptors
    .get(ENV.updateskill_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateSkill(skillObj) {
  return axiosInterceptors
    .post(ENV.updateskill_url, skillObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function withdrawService(appliedId, notesObj) {
  return axiosInterceptors
    .put(ENV.appliedjob_url + "/" + appliedId + "/withdraw", notesObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function applyForJob(jobRequest) {
  return axiosInterceptors
    .post(ENV.applyjob_url, jobRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addPeerRating(peerRequest) {
  return axiosInterceptors
    .post(ENV.peerrating_url, peerRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getRatingReview(status) {
  return axiosInterceptors
    .get(ENV.peerrating_list_url + "?status=" + status)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function resendRequestService(resendId) {
  return axiosInterceptors
    .put(ENV.peerrating_list_url + "/" + resendId + "/" + "resend")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getRating(status) {
  return axiosInterceptors
    .get(ENV.peerrating_list_url + "?status=" + "REQ_REVIEWED")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getAppliedJobsService() {
  return axiosInterceptors
    .get(ENV.appliedjob_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getAveragePeerratingService() {
  return axiosInterceptors
    .get(ENV.AvgPeerrating_url + "/avg")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getAppliedJobDetailsService(jobId) {
  return axiosInterceptors
    .get(ENV.appliedjob_url + "/" + jobId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteAppliedJobService(appliedjobId) {
  return axiosInterceptors
    .delete(ENV.appliedjob_url + "/" + appliedjobId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getAppliedJobdetails(jobId) {
  return axiosInterceptors
    .get(ENV.appliedjobdetails_url + "/" + jobId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getJobdetails(appliedjobId) {
  return axiosInterceptors
    .get(ENV.get_job_url + appliedjobId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getSuggestions(){
  return axiosInterceptors
  .get(ENV.elasticSearch_url )
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

function updatePeerRating(reviewData, requestId) {
  return axiosInterceptors
    .put(ENV.peerrating_url + "/" + requestId, reviewData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getNotifications(){
  return axiosInterceptors.get(ENV.notification_url)
         .then((response)=>{
          return response
         })
         .catch((error)=>{
          return error
         })
}

function updateNotifications(notificationId){
  

  return axiosInterceptors.put(ENV.notification_url+"/"+notificationId+"/read")
        .then((response)=>{
          return response
        })
        .catch((error)=>{
          return error
        })
}

function deletenotification(notificationId) {
  return axiosInterceptors
    .delete(ENV.notification_url+ "/" + notificationId+"/delete")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}